import { IState } from "./index";

export default {
  getState(state: IState): IState {
    return state;
  },
  weather: (state: IState) => {
    const weatherObj: any = {};

    state.weather_list.forEach(item => {
      if (weatherObj[item.dt_txt.split(",")[0]] === undefined) {
        weatherObj[item.dt_txt.split(",")[0]] = [item]
      } else {
        weatherObj[item.dt_txt.split(",")[0]].push(item)
      }
    });

    // To iterate through js object keys and values
    // for (const [key, value] of Object.entries(weatherObj)) {
    //   console.log(key, value);
    // }

    return weatherObj;
  },
  current: (state: IState) => {
    return state.current;
  },
};
